import { configureStore } from '@reduxjs/toolkit'

import crmCommonDataSlice from './features/accountManagement/index'
import { AuthSlice } from './features/authSlice'
import commonSlice from './features/commonSlice'
import regionSlice from './features/regionSlice'
import timeZoneSlice from './features/timezoneSlice'

const rootReducer = configureStore({
  reducer: {
    auth: AuthSlice.reducer,
    crmCommonData: crmCommonDataSlice,
    commonData: commonSlice,
    regionData: regionSlice,
    timezone: timeZoneSlice,
  },
})

export type RootState = ReturnType<typeof rootReducer.getState>
export type AppDispatch = typeof rootReducer.dispatch

export default rootReducer
